import React, { useContext, useEffect, useState } from "react";
import { Carousel, Col, Card, Row, Container } from "react-bootstrap";
import { FaMapMarkerAlt, FaBed, FaRulerCombined, FaBath } from "react-icons/fa";
import { InfoContext } from "../providers/InfosContextProvider";
import { useNavigate } from "react-router-dom";
import { buildPublicAssetPath } from "../utils/publicAssetPath";

const PropertiesDestaque = () => {
  const { houses, texts } = useContext(InfoContext);
  const propertiesDestaque = houses.filter((casa) => casa.destaque);
  const navigate = useNavigate();
  const propertyRefPrefix = texts?.Property?.ref || "Ref: ";

  const [columns, setColumns] = useState(3);

  const handleCardClick = (id) => {
    navigate(`/property/${id}`);
  };

  const chunkArray = (array, size) => {
    const result = [];
    if (array.length <= size) {
      result.push(array);
      return result;
    }
    for (let i = 0; i < array.length; i += size) {
      let chunk = array.slice(i, i + size);
      if (chunk.length < size) {
        chunk = [...chunk, ...array.slice(0, size - chunk.length)];
      }
      result.push(chunk);
    }
    return result;
  };

  useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setColumns(1);
      } else if (width < 992) {
        setColumns(2);
      } else {
        setColumns(3);
      }
    };

    window.addEventListener("resize", updateColumns);
    updateColumns();

    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  const propertiesChunks = chunkArray(propertiesDestaque, columns);

  if (!propertiesDestaque.length) {
    return null;
  }

  return (
    <div className="properties-destaque">
      <Row>
        <div className="titulo">
          <h1 className="titulo-menor">{`${texts.destaque.tituloMenor}`}</h1>
          <h1 className="titulo-maior">{`${texts.destaque.tituloMaior}`}</h1>
          <div className="barra"></div>
        </div>
      </Row>

      <Container className="p-3">
        <Carousel
          interval={5000}
          className="custom-carousel"
          controls={propertiesDestaque.length > columns}
          indicators={propertiesDestaque.length > columns}
        >
          {propertiesChunks.map((chunk, index) => (
            <Carousel.Item key={index}>
              <Row className="mt-15">
                {chunk.map((casa) => (
                  <Col
                    key={`${index}-${casa.id}`}
                    xs={12}
                    md={6}
                    lg={4}
                    className="mb-4"
                  >
                    <Card
                      className="property-card"
                      onClick={() => handleCardClick(casa.id)}
                    >
                      <Carousel
                        interval={null}
                        controls={false}
                        indicators={false}
                        pause={false}
                      >
                        {casa.images.length > 0 ? (
                          casa.images.map((imagem, index) => (
                            <Carousel.Item key={index}>
                              <div className="property-imagem-container">
                                <img
                                  src={buildPublicAssetPath(imagem)}
                                  alt={`Casa ${casa.id}`}
                                  loading="lazy"
                                />
                                <div className="property-valor">
                                  {casa.valor}
                                </div>
                                <span className="ref-tag property-card-ref">
                                  {`${propertyRefPrefix}`} {casa.id}
                                </span>
                              </div>
                            </Carousel.Item>
                          ))
                        ) : (
                          <Carousel.Item>
                            <div className="property-imagem-container">
                              <img
                                src={
                                  buildPublicAssetPath(
                                    "/assets/images/casas-do-nabao-logo.png",
                                  ) ||
                                  buildPublicAssetPath(
                                    "/assets/images/casas-do-nabao-logo.png",
                                  )
                                }
                                alt={`Casa ${casa.id}`}
                                style={{
                                  objectFit: "contain",
                                  padding: "40px",
                                  backgroundColor: "#f8f8f8",
                                }}
                              />
                              <div className="property-valor">{casa.valor}</div>
                              <span className="ref-tag property-card-ref">
                                {`${propertyRefPrefix}`} {casa.id}
                              </span>
                            </div>
                          </Carousel.Item>
                        )}

                        <div className="properties-container">
                          {casa.efficiency.length === 1 ? (
                            <div className="property-efficiency">
                              <img
                                src={buildPublicAssetPath(
                                  `/assets/images/efficiency/${casa.efficiency[0]}_RGB.png`,
                                )}
                                alt={`Eficiência Energética ${casa.efficiency[0]}`}
                              />
                            </div>
                          ) : (
                            casa.efficiency.map((imagem, index) => (
                              <Col
                                key={index}
                                xs={6}
                                className="property-efficiency"
                              >
                                <img
                                  src={buildPublicAssetPath(
                                    `/assets/images/efficiency/${imagem}_RGB.png`,
                                  )}
                                  alt={`Eficiência Energética ${imagem}`}
                                />
                              </Col>
                            ))
                          )}
                        </div>
                      </Carousel>

                      <div className="property-info">
                        <Row>
                          <Col xs={12}>
                            <span>
                              <FaMapMarkerAlt /> {casa.localizacao}
                            </span>
                          </Col>
                        </Row>
                        <Row className="justify-content-center align-items-end">
                          {casa.area && (
                            <Col xs="auto">
                              <span>
                                <FaRulerCombined /> {casa.area}
                              </span>
                            </Col>
                          )}
                          {casa.bedrooms && (
                            <Col xs="auto">
                              <span>
                                <FaBed /> {casa.bedrooms}
                              </span>
                            </Col>
                          )}
                          {casa.bathrooms && (
                            <Col xs="auto">
                              <span>
                                <FaBath /> {casa.bathrooms}
                              </span>
                            </Col>
                          )}
                        </Row>
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </div>
  );
};

export default PropertiesDestaque;
